import React, { ComponentType, Component } from 'react';
import { QueryResult } from 'react-apollo';

import { LoaderTypes } from 'types/app';
import { GetUserSocialConnectionsComponent, SocialAccount } from 'api';
import { QueryManager } from 'components';

import { withUser, IWithUser } from '../';

export interface IWithSocialConnections {
  connections: SocialAccount[];
}

const withSocialConnections = (loader = 'standard' as LoaderTypes) => <T extends {}>(
  ChildComponent: ComponentType<T>,
) => {
  class WithSocialConnections extends Component<T & IWithUser> {
    renderComponent(queryResult: QueryResult) {
      if (!queryResult.data || !queryResult.data.getUserSocialConnections) {
        return null;
      }

      const { items } = queryResult.data.getUserSocialConnections;
      return <ChildComponent {...(this.props as T)} connections={items} />;
    }

    render() {
      const { user } = this.props;
      const variables = { user_id: user.id };

      return (
        <GetUserSocialConnectionsComponent variables={variables}>
          {queryResult => (
            <QueryManager loader={loader} {...queryResult}>
              {() => this.renderComponent(queryResult)}
            </QueryManager>
          )}
        </GetUserSocialConnectionsComponent>
      );
    }
  }

  return withUser(WithSocialConnections);
};

export default withSocialConnections;
